import delegate from "delegate-it";
import Swiper from "swiper";
import { A11y, Autoplay, FreeMode, Keyboard } from "swiper/modules";
import { fireEvent } from "@/scripts/common/util";
import scrollReveal from "@/scripts/components/scroll-reveal";
import "@/styles/components/photo-gallery.css";

const setupGallery = (el) => {
  const container = el.querySelector(".swiper");
  const numSlides = container.querySelectorAll(".swiper-slide").length;
  const backgroundImages = el.querySelector(".background-images");

  const opts = {
    modules: [A11y, Autoplay, FreeMode, Keyboard],
    slidesPerView: "auto",
    speed: 1000,
    spaceBetween: 0,
    centerInsufficientSlides: numSlides != 2,
    centeredSlides: numSlides >= 2,
    freeMode: {
      enabled: true,
      momentumRatio: 0.8,
      momentumVelocityRatio: 0.4,
      minimumVelocity: 0.1,
    },
    keyboard: {
      enabled: true,
    },
    on: {
      touchMove: (_, event) => {
        fireEvent("swiper:drag", document.documentElement, event);
      },
      touchEnd: (_, event) => {
        fireEvent("swiper:dragend", document.documentElement, event);
      },
      resize: (swiper) => {
        swiper.slides.forEach((slide) => {
          const caption = slide.querySelector(".caption-container");

          if (caption) {
            caption.style.width = `${slide.querySelector(".media-container").offsetWidth}px`;
          }
        });

        if (swiper.isLocked) {
          swiper.el.querySelector(".swiper-wrapper").removeAttribute("data-cursor-content");
        } else {
          swiper.el.querySelector(".swiper-wrapper").setAttribute("data-cursor-content", "Drag");
        }
      },
      slideChange: (swiper) => {
        const pos = swiper.activeIndex + 1;

        if (backgroundImages) {
          backgroundImages.querySelector(".active").classList.remove("active");
          backgroundImages.querySelector(`[data-pos="${pos}"]`).classList.add("active");
        }
      },
    },
  };

  if (container.classList.contains("as-autoplay")) {
    opts.autoplay = {
      delay: 3000,
      pauseOnMouseEnter: true,
    };
  }

  new Swiper(container, opts);
};

const handleModalOpen = (e) => {
  const el = e.detail.modalEl;

  if (!el.querySelector(".component-photo-gallery")) {
    return;
  }

  setupGallery(el);
  scrollReveal.reveal(el);
};

const handleExternalSlideTo = (e) => {
  if (!e.detail.id) {
    return;
  }

  const targetSwiper = document.querySelector(`#${e.detail.swiper} .component-photo-gallery .swiper`);

  if (!targetSwiper) {
    return;
  }

  const targetSlide = targetSwiper.querySelector(`.swiper-slide[data-id="${e.detail.id}"]`);
  const slides = Array.from(targetSwiper.querySelectorAll(".swiper-slide"));
  const slideIndex = slides.indexOf(targetSlide);

  targetSwiper.swiper.slideTo(slideIndex);
};

export default {
  init: () => {
    document.querySelectorAll(".component-photo-gallery").forEach((el) => {
      setupGallery(el);
    });

    delegate("html", "modal:populate", handleModalOpen);
    delegate("html", "photogallery:slide", handleExternalSlideTo);
  },
};
